import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import { TailSpin } from 'react-loader-spinner';

import { post } from '../../services/api';
import AdminSection from '../AdminSection/AdminSection';

import './ImportacaoSaqueFacil.css';

function getResponseErrorMessage(response, fallback) {
    return response?.response?.data?.Mensagem
        || response?.response?.data?.Error
        || response?.Mensagem
        || response?.message
        || fallback;
}

export default function ImportacaoSaqueFacil({ setNotifier }) {
    const navigate = useNavigate();
    const inputRef = useRef(null);
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    function limparInput() {
        setFile(null);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    }

    function baixarModelo() {
        const link = document.createElement('a');
        link.href = `${process.env.PUBLIC_URL}/exemploSaqueFacil.csv`;
        link.download = 'exemploSaqueFacil.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    async function importarSaqueFacil() {
        if (!file) {
            setNotifier(false, 'Selecione um arquivo CSV.');
            return;
        }

        try {
            setIsLoading(true);
            const formData = new FormData();
            formData.append('file', file);
            formData.append('idusuario', localStorage.getItem('idusuario'));

            const response = await post(
                '/admin/saque-facil/importacao',
                formData,
                localStorage.getItem('adminToken')
            );

            if (!response?.Sucesso) {
                setNotifier(
                    false,
                    getResponseErrorMessage(response, 'Erro durante a importacao.')
                );
                return;
            }

            setNotifier(true, response.Mensagem);
            limparInput();
        } catch (error) {
            setNotifier(
                false,
                getResponseErrorMessage(error, 'Erro inesperado durante a importacao.')
            );
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="importacao-saque-facil-page">
            <AdminSection
                etapa={1}
                titulo="Importar Saque Fácil Vendedores"
                acoes={(
                    <button type="button" className="download-btn" onClick={baixarModelo}>
                        <DownloadIcon />
                        Exportar modelo
                    </button>
                )}
            >
                <div className="importacao-saque-facil-content">
                    <div className="texto-csv">
                        <strong>Importe seu arquivo clicando no botao abaixo</strong>
                        <span>O arquivo deve ser CSV e separado por ponto e virgula.</span>
                    </div>

                    <div className="importar-csv">
                        <label htmlFor="file_input_saque_facil" className="btn-label">
                            Importar CSV
                        </label>
                        <input
                            ref={inputRef}
                            id="file_input_saque_facil"
                            type="file"
                            accept=".csv,text/csv"
                            onChange={event => setFile(event.target.files?.[0] || null)}
                        />
                        <span className="muda-nome">{file?.name || ''}</span>
                    </div>

                    {file && (
                        <button type="button" className="cancelar-arquivo-btn" onClick={limparInput}>
                            Cancelar
                        </button>
                    )}
                </div>

                <div className="importacao-saque-facil-actions">
                    <button
                        type="button"
                        className="voltar-btn"
                        onClick={() => navigate('/admin/saque-facil')}
                    >
                        Voltar
                    </button>
                    <button
                        type="button"
                        className="enviar-csv-btn"
                        onClick={importarSaqueFacil}
                        disabled={isLoading}
                    >
                        {isLoading
                            ? <TailSpin color="#ffffff" height={20} width={28} />
                            : 'Enviar CSV'}
                    </button>
                </div>
            </AdminSection>
        </div>
    );
}
